import React from "react";

export default function Presentation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32"
    >
      <path
        fill="#76A9FA"
        fillRule="evenodd"
        d="M5.113 4.8a1.6 1.6 0 000 3.2v12.8a3.2 3.2 0 003.2 3.2h4.137l-2.068 2.069a1.6 1.6 0 102.262 2.262l3.669-3.669 3.669 3.669a1.6 1.6 0 002.262-2.262l-2.069-2.07h4.138a3.2 3.2 0 003.2-3.2V8a1.6 1.6 0 000-3.2h-22.4zm18.73 7.531a1.6 1.6 0 00-2.262-2.262l-5.268 5.268-2.07-2.068a1.6 1.6 0 00-2.261 0l-3.2 3.2a1.6 1.6 0 102.262 2.262l2.069-2.069 2.069 2.069a1.6 1.6 0 002.262 0l6.4-6.4z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
